<script lang="ts" setup>
const router = useRouter()
const isNavigating = ref(false)

useHead({
  htmlAttrs: { lang: 'en-US' },
  meta: [
    {
      name: 'ahrefs-site-verification',
      content: '9d8d587a8eef5e0918e0d6bd9e701847647906fdb6b71e412f6b08a8e4ee7c90'
    }
  ],
  script: [
    {
      innerHTML: `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${import.meta.env.VITE_GOOGLE_TAG_ID}');
      `,
      key: 'gtag-config',
    },
  ],
})

useScript({
  src: `https://www.googletagmanager.com/gtag/js?id=${import.meta.env.VITE_GOOGLE_TAG_ID}`,
  async: true,
})

router.beforeEach(() => {
  isNavigating.value = true
})

router.afterEach(async () => {
  await nextTick()
  isNavigating.value = false
})
</script>

<template>
  <MotionConfig
    :transition="{
      duration: isNavigating ? 0 : undefined
    }"
  >
    <RouterView />
  </MotionConfig>
</template>
